var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 15.9997H14C14.55 15.9997 15 15.5497 15 14.9997V9.99973H16.59C17.48 9.99973 17.93 8.91973 17.3 8.28973L12.71 3.69973C12.32 3.30973 11.69 3.30973 11.3 3.69973L6.71 8.28973C6.08 8.91973 6.52 9.99973 7.41 9.99973H9V14.9997C9 15.5497 9.45 15.9997 10 15.9997ZM6 17.9997H18C18.55 17.9997 19 18.4497 19 18.9997C19 19.5497 18.55 19.9997 18 19.9997H6C5.45 19.9997 5 19.5497 5 18.9997C5 18.4497 5.45 17.9997 6 17.9997Z",
    fill: "#0B0909"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrowUp.5a9e6b799e6ad5efe7a8f85a0a3152a7.svg";
export { ForwardRef as ReactComponent };